import { hasPermissions } from '@kontentino/react-permissions-gate';
import { NavigationItem } from 'components/navigation/utils/libs';

export const isNavigationItemPermitted = (
  item: NavigationItem,
  permissionsKeys: string[],
): boolean => {
  if (item.isDisabled) return false;
  if (!item.permissionsScope) return true;

  const scopes = Array.isArray(item.permissionsScope)
    ? item.permissionsScope
    : [item.permissionsScope];

  return hasPermissions(permissionsKeys, scopes);
};
